'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./grid.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Grid(_ref) {
  var children = _ref.children,
      className = _ref.className,
      autoflow = _ref.autoflow,
      sm = _ref.sm,
      m = _ref.m,
      lg = _ref.lg,
      gap = _ref.gap,
      padding = _ref.padding,
      props = _objectWithoutProperties(_ref, ['children', 'className', 'autoflow', 'sm', 'm', 'lg', 'gap', 'padding']);

  var classes = (0, _classnames2.default)('grid', 'grid--gap-' + gap, autoflow && 'grid--autoflow-' + autoflow, sm && 'grid--sm-' + sm, m && 'grid--m-' + m, lg && 'grid--lg-' + lg, padding && 'grid--padding-' + padding, !!window.MSInputMethodContext && !!document.documentMode && 'grid--ie11', className);

  return _react2.default.createElement(
    'div',
    _extends({ className: classes }, props),
    children
  );
}

Grid.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  autoflow: _propTypes2.default.oneOf(['row', 'column']),
  padding: _propTypes2.default.oneOf(['xx-small', 'x-small', 'small', 'medium', 'large', 'x-large', 'xx-large']),
  gap: _propTypes2.default.oneOf(['none', 'xx-small', 'x-small', 'small', 'medium', 'large', 'x-large', 'xx-large']),
  sm: _propTypes2.default.oneOf(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14']),
  m: _propTypes2.default.oneOf(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14']),
  lg: _propTypes2.default.oneOf(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14'])
};

Grid.defaultProps = {
  gap: 'medium',
  autoflow: 'row'
};

exports.default = Grid;